import { useMemo, useState, type FormEvent } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { Button } from '../../components/ui/Button'
import { BrandLogo } from '../../shared/BrandLogo'
import { ibApi, IbApiError } from '../api'

export function IbResetPasswordPage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const token = useMemo(() => (params.get('token') || '').trim(), [params])
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [info, setInfo] = useState('')
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError('')
    setInfo('')
    try {
      if (!token) throw new IbApiError('Reset link is missing or invalid')
      if (password.length < 8) throw new IbApiError('Password must be at least 8 characters')
      if (password !== confirm) throw new IbApiError('Password confirmation does not match')
      const res = await ibApi.resetPassword(token, password)
      setInfo(res.message || 'Password updated')
      window.setTimeout(() => navigate('/ib/login', { replace: true }), 1200)
    } catch (err) {
      setError(err instanceof IbApiError ? err.message : 'Unable to reset password')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="ap-auth ap-auth--ib">
      <div className="ap-auth__card">
        <BrandLogo className="ap-auth__logo" tone="light" variant="mark" />
        <p className="cp-eyebrow">IB / Sub-admin</p>
        <h1>Reset password</h1>
        <p className="cp-muted">Choose a new password for your partner account.</p>
        {error ? (
          <p className="cp-error" role="alert">
            {error}
          </p>
        ) : null}
        {info ? <p className="cp-success">{info}</p> : null}
        <form className="cp-auth__form" onSubmit={(e) => void onSubmit(e)}>
          <label className="cp-field">
            <span className="cp-field__label">New password</span>
            <input
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength={8}
              required
            />
          </label>
          <label className="cp-field">
            <span className="cp-field__label">Confirm password</span>
            <input
              type="password"
              autoComplete="new-password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              minLength={8}
              required
            />
          </label>
          <Button type="submit" disabled={busy || !token}>
            {busy ? 'Updating…' : 'Update password'}
          </Button>
        </form>
        <p className="cp-auth__signin">
          <Link to="/ib/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  )
}
